module.exports = "/images/vendor/flag-icon-css/flags/4x3/fj.svg?60620e850f30b0da0d89bc25f3d69958";